import { render, staticRenderFns } from "./MergeOrdersModal.vue?vue&type=template&id=6148da2c&scoped=true"
import script from "./MergeOrdersModal.vue?vue&type=script&lang=js"
export * from "./MergeOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./MergeOrdersModal.vue?vue&type=style&index=0&id=6148da2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148da2c",
  null
  
)

export default component.exports